import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'locations');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'appointments',
    'locations',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/provider-locations-req.js